module.exports = __webpack_public_path__ + "media/top-go-button.59e9d89a.svg";